<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MB2338, MX321 MFPs">
     MB2338, MX321 MFPs
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety" title="Safety information">
     Safety information
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="product-statements-group.html#d0e43" title="Product statements">
      Product statements
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter" title="Learning about the printer">
     Learning about the printer
    </a>
   </p>
   <div id="divd0e231">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer" title="Finding information about the printer">
      Finding information about the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number" title="Finding the printer serial number">
      Finding the printer serial number
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m" title="Selecting a location for the printer">
      Selecting a location for the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations" title="Printer configurations">
      Printer configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables" title="Attaching cables">
      Attaching cables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel" title="Using the control panel">
      Using the control panel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light" title="Understanding the status of the power button and indicator light">
      Understanding the status of the power button and indicator light
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter" title="Loading paper and specialty media">
     Loading paper and specialty media
    </a>
   </p>
   <div id="divd0e859">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media" title="Setting the size and type of the specialty media">
      Setting the size and type of the specialty media
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1" title="Configuring Universal paper settings">
      Configuring Universal paper settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays" title="Loading trays">
      Loading trays
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder" title="Loading the multipurpose feeder">
      Loading the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays" title="Linking trays">
      Linking trays
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter" title="Paper support">
     Paper support
    </a>
   </p>
   <div id="divd0e1077">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-skyfall-lm-topic.html#supported-paper-sizes-skyfall-lm" title="Supported paper sizes">
      Supported paper sizes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold" title="Supported paper types">
      Supported paper types
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm" title="Supported paper weights">
      Supported paper weights
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper" title="Using recycled paper">
      Using recycled paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper" title="Unacceptable paper">
      Unacceptable paper
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter" title="Printing">
     Printing
    </a>
   </p>
   <div id="divd0e1855">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2" title="Printing from a computer">
      Printing from a computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1881" title="Printing from a mobile device">
      Printing from a mobile device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2" title="Printing a font sample list">
      Printing a font sample list
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying" title="Copying">
     Copying
    </a>
   </p>
   <div id="divd0e2062">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy" title="Using the automatic document feeder and scanner glass">
      Using the automatic document feeder and scanner glass
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies" title="Making copies">
      Making copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos" title="Copying photos">
      Copying photos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-letterhead-topic.html#copying-letterhead" title="Copying on letterhead">
      Copying on letterhead
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper" title="Copying on both sides of the paper">
      Copying on both sides of the paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies" title="Reducing or enlarging copies">
      Reducing or enlarging copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies" title="Collating copies">
      Collating copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies" title="Placing separator sheets between copies">
      Placing separator sheets between copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper" title="Copying multiple pages onto a single sheet">
      Copying multiple pages onto a single sheet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut" title="Creating a copy shortcut">
      Creating a copy shortcut
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing" title="E-mailing">
     E-mailing
    </a>
   </p>
   <div id="divd0e2387">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email" title="Using the automatic document feeder and scanner glass">
      Using the automatic document feeder and scanner glass
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail" title="Configuring the e-mail SMTP settings">
      Configuring the e-mail SMTP settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut" title="Creating an e-mail shortcut">
      Creating an e-mail shortcut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-using-shortcut-number-topic.html#sending-email-using-shortcut-number" title="Sending an e-mail using a shortcut number">
      Sending an e-mail using a shortcut number
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing" title="Faxing">
     Faxing
    </a>
   </p>
   <div id="divd0e3865">
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e3868" title="Setting up the printer to fax">
      Setting up the printer to fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax" title="Using the automatic document feeder and scanner glass">
      Using the automatic document feeder and scanner glass
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax" title="Sending a fax">
      Sending a fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax" title="Scheduling a fax">
      Scheduling a fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut" title="Creating a fax destination shortcut">
      Creating a fax destination shortcut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution" title="Changing the fax resolution">
      Changing the fax resolution
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness" title="Adjusting the fax darkness">
      Adjusting the fax darkness
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log" title="Printing a fax log">
      Printing a fax log
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes" title="Blocking junk faxes">
      Blocking junk faxes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes" title="Holding faxes">
      Holding faxes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax" title="Forwarding a fax">
      Forwarding a fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP" title="Scanning">
     Scanning
    </a>
   </p>
   <div id="divd0e4722">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan" title="Using the automatic document feeder and scanner glass">
      Using the automatic document feeder and scanner glass
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer" title="Scanning to a computer">
      Scanning to a computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut" title="Creating an FTP shortcut">
      Creating an FTP shortcut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut" title="Creating a network folder shortcut">
      Creating a network folder shortcut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-shortcut-number-topic.html#scanning-ftp-server-using-shortcut-number" title="Scanning to an FTP server using a shortcut number">
      Scanning to an FTP server using a shortcut number
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menu-chapter.html#understanding-printer-menu-chapter" title="Understanding the printer menus">
     Understanding the printer menus
    </a>
   </p>
   <div id="divd0e4984">
    <p class="toc-2-style">
     <a href="menus-map-mfp-topic.html#menus-map-mfp" title="Menu map">
      Menu map
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e5347" title="Device">
      Device
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e6719" title="Print">
      Print
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e7713" title="Paper">
      Paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e8008" title="Copy">
      Copy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-mode-topic.html#d0e8375" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e9579" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topics.html#d0e10447" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e11001" title="Network/Ports">
      Network/Ports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-audit-log-topic.html#d0e12536" title="Security">
      Security
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e13101" title="Reports">
      Reports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help-menu" title="Help">
      Help
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu" title="Troubleshooting">
      Troubleshooting
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1" title="Printing the Menu Settings Page">
      Printing the Menu Settings Page
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer" title="Securing the printer">
     Securing the printer
    </a>
   </p>
   <div id="divd0e13463">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot" title="Locating the security slot">
      Locating the security slot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory" title="Erasing printer memory">
      Erasing printer memory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings" title="Restoring factory default settings">
      Restoring factory default settings
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility" title="Statement of Volatility">
      Statement of Volatility
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter" title="Maintaining the printer">
     Maintaining the printer
    </a>
   </p>
   <div id="divd0e13622">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13627" title="Networking">
      Networking
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e14036" title="Cleaning printer parts">
      Cleaning printer parts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group" title="Ordering parts and supplies">
      Ordering parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e14375" title="Replacing parts and supplies">
      Replacing parts and supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer" title="Moving the printer">
      Moving the printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e14603" title="Saving energy and paper">
      Saving energy and paper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e14699" title="Recycling">
      Recycling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams.html#clearing-jams" title="Clearing jams">
     Clearing jams
    </a>
   </p>
   <div id="divd0e14732">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams" title="Avoiding jams">
      Avoiding jams
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations" title="Identifying jam locations">
      Identifying jam locations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door" title="Paper jam in door A">
      Paper jam in door A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door" title="Paper jam in the rear door">
      Paper jam in the rear door
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin" title="Paper jam in the standard bin">
      Paper jam in the standard bin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit" title="Paper jam in the duplex unit">
      Paper jam in the duplex unit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays" title="Paper jam in trays">
      Paper jam in trays
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf" title="Paper jam in the multipurpose feeder">
      Paper jam in the multipurpose feeder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-adf-topic.html#paper-jam-adf" title="Paper jam in the automatic document feeder">
      Paper jam in the automatic document feeder
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter" title="Troubleshooting">
     Troubleshooting
    </a>
   </p>
   <div id="divd0e15046">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems" title="Print quality problems">
      Print quality problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems" title="Printing problems">
      Printing problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e17671" title="Network connection problems">
      Network connection problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e17845" title="Internal option problems">
      Internal option problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e17928" title="Issues with supplies">
      Issues with supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems" title="Paper feed problems">
      Paper feed problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-send-e-mails-topic.html#d0e18506" title="E-mailing problems">
      E-mailing problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e18567" title="Faxing problems">
      Faxing problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-from-computer-topic.html#d0e19266" title="Scanning problems">
      Scanning problems
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support" title="Contacting customer support">
      Contacting customer support
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter" title="Upgrading and migrating">
     Upgrading and migrating
    </a>
   </p>
   <div id="divd0e19881">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e19884" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e20015" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e20213" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices" title="Notices">
     Notices
    </a>
   </p>
   <div id="divd0e20339">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20342" title="Product information">
      Product information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20359" title="Edition notice">
      Edition notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#us-government-rights" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks" title="Trademarks">
      Trademarks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices" title="Licensing notices">
      Licensing notices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels" title="Noise emission levels">
      Noise emission levels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive" title="Waste from Electrical and Electronic Equipment (WEEE) directive">
      Waste from Electrical and Electronic Equipment (WEEE) directive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#e-waste-notice" title="India E-Waste notice">
      India E-Waste notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20473" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal" title="Product disposal">
      Product disposal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20507" title="Lithium-ion rechargeable battery">
      Lithium-ion rechargeable battery
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542" title="Regulation (EU) 2023/1542">
      Regulation (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling" title="Returning Lexmark cartridges for reuse or recycling">
      Returning Lexmark cartridges for reuse or recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice" title="Static sensitivity notice">
      Static sensitivity notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information" title="Temperature information">
      Temperature information
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice" title="Laser notice">
      Laser notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption" title="Power consumption">
      Power consumption
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20755" title="Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020">
      Applicability of Regulation (EU) 2019/2015 and (EU) 2019/2020
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20760" title="The UK Product Security and Telecommunications Infrastructure Act 2022 (PSTI Act)&mdash;Summary Statement of Compliance">
      The UK Product Security and Telecommunications Infrastructure Act 2022 (PSTI Act)&mdash;Summary Statement of Compliance
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20768" title="Thailand NBTC technical standards conformity statementคำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย">
      Thailand NBTC technical standards conformity statement
      <br/>
      คำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment" title="Regulatory notices for telecommunication terminal equipment">
      Regulatory notices for telecommunication terminal equipment
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#fcc-requirements" title="Notice to users of the US telephone network: FCC requirements">
      Notice to users of the US telephone network: FCC requirements
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-the-canadian-telephone-network" title="Notice to users of the Canadian telephone network">
      Notice to users of the Canadian telephone network
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20813" title="Notice to users of the New Zealand telephone network">
      Notice to users of the New Zealand telephone network
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20833" title="Japanese telecom notice">
      Japanese telecom notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20870" title="Regulatory notices for wireless products">
      Regulatory notices for wireless products
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice" title="Modular component notice">
      Modular component notice
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation" title="Exposure to radio frequency radiation">
      Exposure to radio frequency radiation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#industry-canada-en2" title="Innovation, Science and Economic Development Canada">
      Innovation, Science and Economic Development Canada
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e20904" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e21008" title="United Kingdom (UK) conformity">
      United Kingdom (UK) conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#federal-communications-commission-fcc-compliance-information-statement" title="Federal Communications Commission (FCC) compliance information statement">
      Federal Communications Commission (FCC) compliance information statement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice-classb" title="日本の VCCI 規定">
      日本の VCCI 規定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b" title="European Community (EC) directives conformity">
      European Community (EC) directives conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e21083" title="United Kingdom (UK) conformity">
      United Kingdom (UK) conformity
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#statement-of-limited-warranty" title="STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS">
      STATEMENT OF LIMITED WARRANTY FOR LEXMARK LASER PRINTERS, LEXMARK LED PRINTERS, AND LEXMARK MULTIFUNCTION LASER PRINTERS
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue